import * as actions from './actions'
import { EmptyStatePageState } from './model'
import { EmptyStateActions } from './actions'

const initialState: EmptyStatePageState =  <EmptyStatePageState> {
  is404: true,
  emptyStateTitle: 'The page you are looking for could not be found.',
  emptyStateSubtitle: undefined,
  redirectLink: undefined
};

const reducer = (state: EmptyStatePageState = initialState, action: EmptyStateActions): EmptyStatePageState => {
  switch (action.type) {
      case actions.ChangeEmptyState:
          return {
            ...state,
            is404: action.payload.is404,
            emptyStateTitle: action.payload.emptyStateTitle,
            emptyStateSubtitle: action.payload.emptyStateSubtitle,
            redirectLink: action.payload.redirectLink
          };
    default:
      return state
  }
};

export default reducer
